module.exports = __webpack_public_path__ + "static/media/TikTok.0e75cd6f.svg";